import { Spinner } from '@chakra-ui/core';
import { Td, Tr } from '@chakra-ui/table';
import React from 'react';

interface TableLoaderProps {
  columnCount: number;
}

export function TableLoader({ columnCount }: TableLoaderProps): JSX.Element {
  return (
    <Tr>
      <Td colSpan={columnCount} textAlign="center" py={5}>
        <Spinner />
      </Td>
    </Tr>
  );
}
